export default __webpack_public_path__ + "static/media/OSM-main.7a984991.jpg";